import React from 'react'
import { Switch } from 'common/components/Switch/Switch'
import { useListenEnableQuizContentUnlockQuery, useSetEnableQuizContentUnlockMutation } from '../appOnboardingQuizApi'

function QuizContentUnlockCard({ coachOrgId }) {
  const { data: enableQuizContentUnlock } = useListenEnableQuizContentUnlockQuery({ coachOrgId })
  const [setEnableQuizContentUnlock] = useSetEnableQuizContentUnlockMutation()

  const isLoading = enableQuizContentUnlock === undefined || enableQuizContentUnlock?.isLoading
  const isEnabled = enableQuizContentUnlock === true

  return (
    <div className='bg-[#F5F5F5] border border-gray-300 rounded-lg py-2 px-3 w-[380px] mb-2'>
      <Switch
        name='enableQuizContentUnlock'
        labelClasses='justify-between w-full'
        labelContainerClasses='text-sm whitespace-nowrap'
        label='Unlock 1 paid workout after completion'
        switchOuterClasses='!w-10 !h-6'
        switchInnerClasses='!w-4 !h-4'
        disabled={isLoading}
        isChecked={isEnabled}
        onChange={() => {
          if (isLoading) {
            return
          }
          setEnableQuizContentUnlock({ coachOrgId, enabled: !isEnabled })
        }}
      />
    </div>
  )
}

export default QuizContentUnlockCard
